<template>
  <div class="sign-in ">
    <loading-spinner v-if="view.loading"/>
    <div v-else class="row">
      <div class="col-md-6 loft-col">
        <div class="row justify-content-center">
          <div class="col-md-9">
            <section-header class="mt-5 mb-3" title="登入" subtitle="Sign In"/>
            <div class="text-secondary mb-4">請輸入您的 E-mail 帳號與密碼進行登入</div>
            <form class="needs-validation" :class="{ 'was-validated': isValidated }" @submit.prevent="onSignInClicked" novalidate>
              <div class="form-floating mb-3">
                <input id="input-account" type="text" class="form-control" placeholder="E-mail" maxlength="64" v-model="email" required>
                <label for="input-account" class="text-secondary">E-mail</label>
                <div class="invalid-feedback">請輸入您的E-mail</div>
              </div>
              <div class="form-floating mb-3">
                <input id="input-passwd" type="password" class="form-control" placeholder="Password" maxlength="64" v-model="password" required>
                <label for="input-passwd" class="text-secondary">Password</label>
                <div class="invalid-feedback">請輸入您的密碼</div>
              </div>
              <div class="form-check mb-3">
                <input id="input-remember" type="checkbox" class="form-check-input loft-check-input" v-model="rememberMe">
                <label for="input-remember" class="text-secondary">Remember Me</label>
              </div>
              <button class="btn btn-lg btn-dark w-100 mb-2" type="submit">登入</button>
            </form>
            <div class="mb-5 text-center"><router-link to="/w/forget-passwd" class="text-secondary">忘記密碼？</router-link></div>
            <!-- <button class="btn btn-lg btn-fb w-100 mb-2" @click="onSignInFbClicked"><img src="@/assets/img/ic-logo-fb.svg" alt="facebook login">Sign in with Facebook</button> -->
          </div>
        </div>
      </div>
      <div class="col-md-6 loft-col">
        <div class="row justify-content-center">
          <div class="col-md-9">
            <section-header class="mt-5 mb-3" title="建立新帳號" subtitle="Create Your Account"/>
            <div class="text-secondary mb-5">創建您的 Loft29 會員帳號以追蹤您的訂單、隨時更新您的個人資訊，以及享有更多的會員福利！</div>
            <router-link to="/w/create-account" class="btn btn-lg btn-dark w-100 mb-2">創建帳號</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import authApi from '@/api/auth.js'
import { mapMutations } from 'vuex'
import SectionHeader from '@/components/SectionHeader.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default {
  name: 'SignIn',
  components: {
    SectionHeader,
    LoadingSpinner
  },
  data () {
    return {
      view: {
        loading: true
      },
      redirect: null,
      email: null,
      password: null,
      rememberMe: true,
      isValidated: false
    }
  },
  mounted () {
    // check if cookie exists
    var cookieEmail = localStorage.getItem('email')
    if (cookieEmail) {
      this.rememberMe = true
      this.email = cookieEmail
    }

    // TODO: if auth exists, replace route to home page
    if (this.$route.query.code) {
      // check csrf first
      var csrf = localStorage.getItem('csrf')
      localStorage.removeItem('csrf')
      var state = JSON.parse(decodeURIComponent(this.$route.query.state))
      if (!csrf || csrf !== state.csrf) {
        // unknown redirect source, stop
        alert('invlid state')
        localStorage.clear()
        return
      }
      this.redirect = state.redirect
      // auth user according to provider
      this.apiAuthFb(this.$route.query.code)
    } else {
      this.view.loading = false
    }
  },
  methods: {
    ...mapMutations([
      'setAlert',
      'setAuthToken'
    ]),
    // loft
    apiSignIn: function () {
      if (!this.email || !this.password) {
        this.isValidated = true
        return
      }
      var self = this
      authApi.signIn(this.email, this.password, function (err, rspData) {
        if (err) {
          self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `無法登入：${rspData} (${err})` })
          return
        }
        // update remember me option
        if (self.rememberMe) {
          localStorage.setItem('email', self.email)
        } else {
          localStorage.removeItem('email')
        }
        // update token
        localStorage.setItem('id', rspData.userId)
        localStorage.setItem('token', rspData.jwtToken)
        self.setAuthToken({ id: rspData.userId, token: rspData.jwtToken })
        if (self.$route.query.redirect) {
          self.redirect = self.$route.query.redirect
        }
        self.signedInRedirect()
      })
    },
    // facebook
    apiSignInFb: function () {
      if (this.$route.query.redirect) {
        this.redirect = this.$route.query.redirect
      }
      authApi.signInFb(this.createCsrfToken(), this.redirect)
    },
    apiAuthFb: function (code) {
      var self = this
      console.log('auth fb: ', code)
      authApi.authFb(code, function (err, rspData) {
        if (err) {
          self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `無法登入：${rspData} (${err})` })
          return
        }
        console.log(rspData)
        localStorage.setItem('id', rspData.userId)
        localStorage.setItem('token', rspData.jwtToken)
        self.setAuthToken({ id: rspData.userId, token: rspData.jwtToken })
        self.signedInRedirect()
      })
    },
    onSignInClicked () {
      this.apiSignIn()
    },
    onSignInFbClicked () {
      this.apiSignInFb()
    },
    signedInRedirect: function () {
      this.$router.replace(!this.redirect ? '/w/' : this.redirect)
    },
    createCsrfToken: function () {
      var array = new Uint32Array(2)
      window.crypto.getRandomValues(array)
      const ret = array.join('')
      localStorage.setItem('csrf', ret)
      return ret
    }
  }
}
</script>

<style scoped>
.btn-fb {
  background-color: #3b5998;
  border-color: #3b5998;
  color: white;
  font-size: 1rem;
  position: relative;
  height: 48px;
}
.btn-fb img {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 1.5rem;
}
@media screen and (min-width: 768px) {
  .sign-in .loft-col:last-child {
    border-left: 1px solid;
    border-color: var(--bs-dark);
  }
}
</style>
